import { Edit } from '@mui/icons-material';
import { Card, CardContent, CardHeader, IconButton, Tooltip } from '@mui/material';
import ArgonBox from 'components/ArgonBox';
import ArgonTypography from 'components/ArgonTypography';
import { CustomDescrypt } from 'global/func';
import { postDataWithResponse } from 'global/postFunc';
import React, { useEffect, useState } from 'react'
import userStore from 'store/userStore';
import EditData from './EditData';
import { MaterialReactTable } from 'material-react-table';

const AnggaranOpd = () => {
    const { user, tahunAnggaran, addReq } = userStore(state => ({ user: state.user, tahunAnggaran: state.tahunAnggaran, addReq: state.addReq }));
    const decryptedUser = (user === null || user === undefined || user === '') ? "" : JSON.parse(CustomDescrypt(user));

    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)
    const [updating, setUpdating] = useState(false)

    const [editData, setEditData] = useState({})

    const reqAnggaranOpd = () => {
        setLoading(true)
        addReq()
        console.log('Req Anggaran');
        postDataWithResponse(
            '/sa/opd/anggaran-opd',
            {
                ta: tahunAnggaran.ta,
            },
            decryptedUser,
            (res) => {
                setLoading(false)
                console.log(res);
                setData(res)
            },
            (res) => {
                setLoading(false)
                console.log(res)
            }

        )
    }

    useEffect(() => {
        reqAnggaranOpd()
        console.log(data);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updating])

    const [open, setOpen] = useState(false);
    // const handleOpen = (params) => {
    //     setOpen(true)
    //     setEditData(params)
    //     console.log(params);
    // };
    const handleClose = () => setOpen(false);

    const columns = [
        {
            accessorKey: 'nama_pd',
            header: 'OPD',
            Cell: ({ cell }) => (
                <>
                    <ArgonTypography
                        fontSize='small'
                        variant="inherit"
                    >
                        {cell.getValue()}
                    </ArgonTypography>
                    <ArgonTypography
                        fontSize='small'
                        variant="inherit"
                    >
                        {cell.row.original.kd_pd}
                    </ArgonTypography>
                </>
            )
        },
        {
            accessorKey: 'anggaran_opd.anggaran',
            header: 'Anggaran',
            Cell: ({ cell }) => (
                <ArgonTypography
                    variant="inherit"
                    fontSize="small"
                >
                    {
                        parseInt(cell.getValue())?.toLocaleString?.('id-ID', {
                            style: 'currency',
                            currency: 'IDR',
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                        })
                    }
                </ArgonTypography>
            )
        },
    ];

    return (
        <ArgonBox py={3}>
            <ArgonBox mb={3}>
                <Card>
                    <CardHeader
                        title={
                            <ArgonTypography variant='h6'>Anggaran OPD</ArgonTypography>
                        }
                    />
                    <CardContent>
                        <MaterialReactTable
                            columns={columns}
                            data={data}
                            // enableExpanding
                            // enableExpandAll
                            muiTableHeadCellProps={{
                                sx: {
                                    fontSize: '0.875rem !important',
                                    color: 'text.main !important'
                                }
                            }}
                            muiTableFooterCellProps={{
                                sx: {
                                    fontSize: '0.875rem !important',
                                    color: 'text.main !important'
                                }
                            }}
                            muiTopToolbarProps={{
                                sx: { fontSize: '0.875rem' }
                            }}
                            initialState={{
                                expanded: true
                            }}
                            enablePagination={false}
                            enableColumnFilters={false}
                            enableSorting={true}
                            state={{ isLoading: loading }}
                            enableRowActions={true}
                            positionActionsColumn='last'
                            displayColumnDefOptions={{
                                'mrt-row-actions': {
                                    header: 'Action', //change header text
                                    size: 5, //make actions column wider
                                    alignment: 'left'
                                }
                            }}
                            renderRowActions={({ row }) => [
                                <Tooltip title="Edit">
                                    <IconButton aria-label="edit" onClick={() => {
                                        setOpen(true)
                                        setEditData(row.original)
                                        console.log('edit');
                                    }} color="success">
                                        <Edit color='success' />
                                    </IconButton>
                                </Tooltip>
                            ]}
                            enableRowNumbers
                            rowNumberDisplayMode='static'
                        />
                    </CardContent>
                </Card>
            </ArgonBox>
            <EditData
                data={editData}
                ta={tahunAnggaran}
                open={open}
                handleClose={handleClose}
                addReq={addReq}
                decryptedUser={decryptedUser}
                updating={updating}
                setUpdating={setUpdating}
            />
        </ArgonBox>
    )
}

export default AnggaranOpd